export default {
  reporteMarketing: [],
  reporteMarketingAgencia: [],
  reporteMarketingAgenciaPorCamino: [],
  reportePasajerosProcedencia: {},
  reporteAsignacionesPorTrabajador: [],
  reporteReservasAsignadasTrabajador: [],
};
